exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".definition-table[data-v-afdf6182] {\n  width: 100%;\n  margin-bottom: 2rem;\n  border-width: 1px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n}\n.definition-table dt[data-v-afdf6182] {\n  font-weight: 600;\n  text-align: left;\n}\n.definition-table dt[data-v-afdf6182],\n.definition-table dd[data-v-afdf6182] {\n  border-width: 1px;\n}\n", ""]);

// exports
